import React from 'react';
import LanguageDropdown from '../../common/LanguageDropdown';
import type { SurveyHeaderProps } from '../SurveyPage.types';

/**
 * SurveyHeader Component
 *
 * Displays the survey title, optional description (with HTML support), and language selector.
 * This component is responsible for the top section of the survey that provides
 * context and settings to the user.
 *
 * @param props - Component props
 * @returns The rendered survey header
 *
 * @example
 * <SurveyHeader
 *   title="Customer Satisfaction Survey"
 *   description="<p>Help us <strong>improve</strong> our services</p>"
 *   availableLanguages={['en', 'fr', 'es']}
 * />
 */
export const SurveyHeader: React.FC<SurveyHeaderProps> = ({
  title,
  description,
  availableLanguages,
}) => {
  return (
    <>
      <div className="survey-header">
        <h1 className="survey-title">{title}</h1>
        {description && (
          <div
            className="survey-description"
            dangerouslySetInnerHTML={{ __html: description }}
          />
        )}
      </div>
      {availableLanguages.length > 1 && (
        <div className="survey-settings-container">
          <LanguageDropdown availableLanguages={availableLanguages} />
        </div>
      )}
    </>
  );
};
